import { type ReactNode } from 'react';

interface HeroBodyProps {
  children: ReactNode;
}

const HeroBody = ({ children }: HeroBodyProps) => <div className="hero__body">{children}</div>;

export default HeroBody;
